<div class="atn-ds-page">
  <div atnDsMeasuredElement>
    <ng-content select="[pageHeader]"></ng-content>
  </div>
  <div
    class="atn-ds-page__body"
    [style]="bodyStylesSg()"
  >
    <div
      #pageAside
      [class.atn-ds-page__body-aside]="pageAsideExistsSg()"
      [style.display]="pageAsideExistsSg() ? 'block' : 'none'"
    >
      <ng-content select="[pageAside]"></ng-content>
    </div>
    <div
      class="atn-ds-page__body-content"
      [class.atn-ds-page__body-content--scrollable]="scrollableSg()"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
